import callApi from 'common/callApi';
import { WebInquiry } from 'common/models';

export const getCompany = catereaseCP =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${catereaseCP}/companies`))
    .then(result => {
      if (result.data) {
        return result.json();
      } else {
        return result;
      }
    });

export const submitRequest = (webInquiry: WebInquiry) =>
  dispatch => dispatch(callApi('v1/companies/SendWebInquiry', { body: webInquiry }));
